'use client';

import {useEffect} from 'react';

import {AppStub, AppType, AppWithDeviceSpecifics} from '@web-catalog/types';

import {useSetHeaderAppType} from '@web-catalog/store';

import {setAppInfoAnalytics} from '@web-catalog/utils/analytics/logEvent';

export const AppTypeHandler = ({
  app,
}: {
  app?: AppWithDeviceSpecifics | AppStub;
}) => {
  const setAppType = useSetHeaderAppType();
  useEffect(() => {
    setAppType(app?.appType || AppType.MAIN);
  }, [app?.appType, setAppType]);

  useEffect(() => {
    setAppInfoAnalytics(app);
  }, [app]);
  return null;
};
